module.exports = __webpack_public_path__ + "static/nagrade-f9cdc87b32906337891c17b04687926e.png";